import { SurgicalPendencyList } from 'presentation/doctor/components/SurgicalPendencyList'
import React from 'react'

export const Pendencies = () => {
  return <SurgicalPendencyList />
}
